export const invalidEmail = [
  '~',
  '!',
  '$',
  '%',
  '^',
  '&',
  '*',
  '_',
  '=',
  '+',
  '}',
  '{',
  "'",
  '?',
  '-',
];
